import type { Endpoint, Route, Request, RequestArgs } from '../types.no-deps'

export const route: Route = { method: 'POST', pattern: '/api/notifications/add-subscription' }

export interface PushSubscription {
    endpoint: string
    keys: {
        p256dh: string
        auth: string
    }
}

type Params = never
type Body = { subscription: PushSubscription }
type Query = never
type Output = { success: boolean }

export type AddSubscriptionEndpoint = Endpoint<Params, Body, Query, Output>

export const addSubscriptionRequest = (request: Request, args: RequestArgs<AddSubscriptionEndpoint>) =>
    request<AddSubscriptionEndpoint>(route, args)
